module.exports = __webpack_public_path__ + "media/src/images/zu_exp_01-794e3636911c34ace39f6a77e8300729.gif";